export const inspectTable2 = [
  { type: 'section', id: 's1', title: '1. 도급·용역·위탁 사업' },
  { id: '도급_01', content: '1) 안전·보건 협의체 구성 및 운영(운영일지, 회의록 작성, 월 1회)' },
  { id: '도급_02', content: '2) 작업장 순회점검(주 1회)' },
  { id: '도급_03', content: '3) 안전보건교육 지원 및 실시 확인(특별안전교육 실시여부 확인 및 지도)' },
  { id: '도급_04', content: '4) 경보체계 운영과 대피방법 등 훈련' },
  { id: '도급_05', content: '5) 수급업체 위생시설 설치 또는 이용' },
  { id: '도급_06', content: '6) 같은 장소 내 관계수급인의 작업시기·내용, 안전보건조치 등의 확인 및 조정' },
  { id: '도급_07', content: '7) 작업장 합동 안전·보건 점검' },
  { id: '도급_08', content: '8) 사업장 안전보건관리규정의 작성' },
  { id: '도급_09', content: '9) 위험성평가 실시(도급인, 수급인 각각)' },
  { id: '도급_10', content: '10) 작업환경 측정(유해인자에 노출되는 근로자가 있는 경우)' },
  { id: '도급_11', content: '11) 도급인의 안전 및 보건에 관한 정보 제공 등(위험작업 여부 문서 제공 등)' },
  { id: '도급_12', content: '12) 도급인의 수급인에 대한 시정조치(위반사항 발생 시 시정조치 여부)' },
  { id: '도급_13', content: '13) 적격 수급인 선정 의무(적격수급업체 여부 평가, 안전보건준수서약서 징구 등)' },
  { type: 'section', id: 's2', title: '2. 발주공사 사업' },
  { id: '발주_01', content: '1) 안전보건대장 작성(50억원 이상 공사)' },
  { id: '발주_02', content: '2) 건설재해예방지도기관 계약 체결(1억이상 120억 미만 공사)' },
  { id: '발주_03', content: '3) 산업안전보건관리비 적정 계상(2천만원 이상 공사)' },
  { id: '발주_04', content: '4) 공사기간 단축 및 정당한 사유없는 공법 변경 금지(모든 공사)' },
  { id: '발주_05', content: '5) 공사기간 연장(모든 공사)' },
];
